module.exports = __webpack_public_path__ + "static/lizard-e56888b3a9551bc86b0cd7860fc13072.png";